import React from 'react';

// PM‑editable copy separated from UI
export const debtLiabilitiesTourCopy = {
  headerTitle: 'Debt & Liabilities',
  headerBody: 'Track all your loans and liabilities with strategic paydown planning to become debt-free faster.',
  categoriesTitle: 'Debt Categories',
  categoriesBody: 'Organize debts by type - Home Loans, Car Loans, Personal Loans, Credit Cards, and more.',
  summaryTitle: 'Debt Summary',
  summaryBody: 'See total outstanding debt, monthly EMI obligations, average interest rate, and debt-to-income ratio.',
  tableTitle: 'Loan Details',
  tableBody: 'Manage each loan with principal, interest rate, EMI, and remaining tenure. Track payoff progress.',
  chartTitle: 'Debt Paydown Chart',
  chartBody: 'Visualize your path to becoming debt-free. See how your total debt decreases over time.',
  eventsTitle: 'Prepayment Events',
  eventsBody: 'Plan lump-sum prepayments to reduce interest burden and accelerate your debt-free timeline.',
};

const Tip = ({ title, body }) => (
  <div>
    <div style={{ fontWeight: 600, color: 'var(--foreground, #111827)' }}>{title}</div>
    <div style={{ marginTop: 6, fontSize: 14, color: 'var(--muted-foreground, #6B7280)' }}>{body}</div>
  </div>
);

export const getDebtLiabilitiesTourSteps = () => [
  {
    target: '[data-tour="debt-header"]',
    content: <Tip title={debtLiabilitiesTourCopy.headerTitle} body={debtLiabilitiesTourCopy.headerBody} />,
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="debt-summary"]',
    content: <Tip title={debtLiabilitiesTourCopy.summaryTitle} body={debtLiabilitiesTourCopy.summaryBody} />,
    placement: 'bottom',
  },
  {
    target: '[data-tour="debt-table"]',
    content: <Tip title={debtLiabilitiesTourCopy.tableTitle} body={debtLiabilitiesTourCopy.tableBody} />,
    placement: 'top',
  },
  {
    target: '[data-tour="debt-categories"]',
    content: <Tip title={debtLiabilitiesTourCopy.categoriesTitle} body={debtLiabilitiesTourCopy.categoriesBody} />,
    placement: 'bottom',
  },
  {
    target: '[data-tour="debt-events"]',
    content: <Tip title={debtLiabilitiesTourCopy.eventsTitle} body={debtLiabilitiesTourCopy.eventsBody} />,
    placement: 'top',
  },
  {
    target: '[data-tour="debt-chart"]',
    content: <Tip title={debtLiabilitiesTourCopy.chartTitle} body={debtLiabilitiesTourCopy.chartBody} />,
    placement: 'top',
  },
];
